import { useState } from "react";

import { type LatLngBoundsLiteral } from "leaflet";
import { isMobile } from "react-device-detect";
import { useMap } from "react-leaflet";

function ChangeMapView({ bounds }: { bounds: LatLngBoundsLiteral | undefined }): null {
  const [lastBounds, setLastBound] = useState<LatLngBoundsLiteral>();
  if (!lastBounds || JSON.stringify(lastBounds) !== JSON.stringify(bounds)) setLastBound(bounds);
  const map = useMap();
  if (isMobile) {
    map.dragging.disable();
    if (map.tapHold) map.tapHold.disable();
  }
  if (lastBounds && bounds && JSON.stringify(lastBounds) !== JSON.stringify(bounds)) {
    if (Math.abs(bounds[0][0] - bounds[1][0]) < 0.000_05 || Math.abs(bounds[0][1] - bounds[1][1]) < 0.000_05) {
      map.setMaxZoom(19);
    } else {
      map.setMaxZoom(21);
    }
    map.fitBounds(bounds);
  }
  return null;
}

export default ChangeMapView;
